import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { NewsItemRankUp } from "./NewsItemRankUp";
import { CurrencyType, NewsCurrencyComponent } from "../NewsCurrencyComponent";
import { IDestroyOptions, Text } from "pixi.js";
import { TextWithUnderline } from "by/gamefactory/cityversetycoon/scenes/game/components/TextWithUnderline";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { INewsItemOptions } from "./NewsItem";
import { CancellationToken } from "async/CancellationToken";
import { ILatestNewsController } from "../../controllers/ILatestNewsController";

export class NewsItemRankUpRenter extends NewsItemRankUp {
    private static readonly GREAT_NEWS_TEXT = "GREAT NEWS! YOUR BUILDING HAS ADVANCED\nIN RANK, AND AS A REWARD, YOU'VE\nRECEIVED";
    private static readonly LEARN_MORE_TEXT = 'LEARN MORE';

    private readonly newsController: ILatestNewsController;
    private readonly options: NewsItemRankUpRenterOptions;
    private readonly cancellationToken: CancellationToken;

    private buildingRankUpText: Text;
    private currencyComponent: NewsCurrencyComponent;
    private learnMoreButton: TextWithUnderline;

    public constructor(
        id: string, 
        newsResources: LatestNewsResourcePackage, 
        newsController: ILatestNewsController, 
        options: NewsItemRankUpRenterOptions,
        cancellationToken: CancellationToken
    ) {
        super(id, newsResources);
        this.newsController = newsController;
        this.options = options;
        this.cancellationToken = cancellationToken;
        this.build();
        this.layout();
        this.learnMoreButton.on("pointerdown", this.onLearnMoreClickHandle, this);
    }

    private build(): void {
        this.buildingRankUpText = new Text(NewsItemRankUpRenter.GREAT_NEWS_TEXT, new NewsTextStyle());
        this.currencyComponent = new NewsCurrencyComponent(this.newsResources, this.options.currencyNumber, CurrencyType.COINS);
        this.learnMoreButton = new TextWithUnderline(NewsItemRankUpRenter.LEARN_MORE_TEXT, new NewsTextStyle(), 0, -12, 3);
        this.learnMoreButton.eventMode = 'static';
        this.addChild(this.buildingRankUpText, this.currencyComponent, this.learnMoreButton);
    }

    private layout(): void {
        this.buildingRankUpText.position.set(277, 28);
        this.currencyComponent.position.set(386, 115);
        this.learnMoreButton.position.set(277, 157);
    }

    private async onLearnMoreClickHandle(): Promise<void> {
        this.learnMoreButton.eventMode = 'auto';
        await this.newsController.updateLatestNewsInfo(this.id);
        await this.newsController.showRankUp(this.options.currencyNumber, this.options.buildingRankUpLevel, this.cancellationToken);
        this.learnMoreButton.eventMode = 'static';
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.learnMoreButton.off("pointerdown", this.onLearnMoreClickHandle, this);
        super.destroy(options);
    }
}

export class NewsItemRankUpRenterOptions implements INewsItemOptions {
    public readonly currencyNumber: number;
    public readonly buildingRankUpLevel: number;

    public constructor(currencyNumber: number, buildingRankUpLevel: number) {
        this.currencyNumber = currencyNumber;
        this.buildingRankUpLevel = buildingRankUpLevel;
    }
}
